import React from "react";
import FlowRender from '@/components/flows/FlowRender';
import { useParams } from "react-router-dom";

export default function FlowSelectionPage() {
    const { flowId } = useParams();
    
    return (
        <div className="smart-page-bg min-h-screen h-full pt-16 sm:px-4">
            <FlowRender flowId={flowId} />
        </div>
    );
}
